import { useRef } from "react";

import { gsap, prefersReducedMotion, useGSAP } from "@/animations/gsap";
import { revealOnScroll, type RevealOptions } from "@/animations/reveal";

/**
 * 返回一个 ref，挂到容器上即可对其内部 [data-reveal] 元素做滚动揭示。
 * 减弱动画偏好下直接显示，不做位移。
 */
export function useReveal<T extends HTMLElement = HTMLDivElement>(options: RevealOptions = {}) {
  const scope = useRef<T>(null);

  useGSAP(
    () => {
      if (!scope.current) return;
      if (prefersReducedMotion()) {
        gsap.set(scope.current.querySelectorAll(options.selector ?? "[data-reveal]"), { opacity: 1, y: 0 });
        return;
      }
      revealOnScroll(scope.current, options);
    },
    { scope },
  );

  return scope;
}
